import type { Profile } from 'api/connector/types'

import type { LinkedInLoginProfile } from './types'

function mapLoginProfileToConnectorProfile(
	profile: LinkedInLoginProfile | null | undefined
): Profile | null {
	if (!profile?.entityId) {
		const result = null
		return result
	}

	const result: Profile = {
		entityId: profile.entityId,
		firstName: profile.firstName ?? '',
		fullName: null,
		lastName: profile.lastName ?? '',
		objectId: profile.objectId ?? '',
		occupation: profile.occupation ?? '',
		picture: profile.picture ?? '',
		publicIdentifier: profile.publicIdentifier ?? '',
		salesNavigatorEntityId: profile.salesNavigatorEntityId ?? null
	}
	return result
}

export { mapLoginProfileToConnectorProfile }
